// extracted by mini-css-extract-plugin
export default {"overlay":"Ay-z","bodyOpen":"By-z","content":"Cy-z","header":"Dy-z","close":"Ey-z","closeNoHeading":"Fy-z"};